import './index.css'
import { createApp } from 'vue'
import App from './App.vue'
import { Chart, registerables } from "chart.js";
import './assets/tailwind.css'
import { createPinia } from 'pinia'
import SiteRouter from '../router'

const app = createApp(App);


app.use(SiteRouter)
app.use(createPinia())
import {useApiStore} from "@/stores/ApiStore";
import {i18n} from "@/i18n";

const apiDataStore = useApiStore();

apiDataStore.$subscribe(setLanguage, { detached: true});


function setLanguage(){
    i18n.global.locale.value = useApiStore().getLang
}



Chart.register(...registerables);
app.use(i18n);
app.mount('#app')
